
import Vue from "vue";
import router from "vue-router";

Vue.use(router);

const constantRoutes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/index"),
  },
  {
    path: "/info",
    name: "info",
    component: () => import("@/views/info/index"),
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/home/index"),
  },
  {
    path: "/style",
    name: "style",
    component: () => import("@/views/style/index"),
  },
  {
    path: "/orderlist",
    name: "orderlist",
    component: () => import("@/views/order/index"),
  },
  {
    path: "/orderDeatils",
    name: "orderdeatils",
    component: () => import("@/views/order/details"),
  },
  {
    path: "/laser",
    name: "laser",
    component: () => import("@/views/laser/index"),
  },
  {
    path: "/shipment",
    name: "shipment",
    component: () => import("@/views/shipment/index"),
  },
  {
    path: "/settleShipment",
    name: "settleShipment",
    component: () => import("@/views/shipment/settle"),
  },
  {
    path: "/processing",
    name: "processing",
    component: () => import("@/views/processing/index"),
  },
  {
    path: "/laserAdd",
    name: "laserAdd",
    component: () => import("@/views/laser/add"),
  },
  {
    path: "/shipmentAdd",
    name: "shipmentAdd",
    component: () => import("@/views/shipment/add"),
  },
  {
    path: "/processingAdd",
    name: "processingAdd",
    component: () => import("@/views/processing/add"),
  }
];

// 防止连续点击多次路由报错
const routerPush = router.prototype.push;
router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err);
};

const Router = new router({
  mode: "history", // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
});



export default Router;
